import { render, staticRenderFns } from "./loseDetail.vue?vue&type=template&id=34346275&scoped=true&"
import script from "./loseDetail.vue?vue&type=script&lang=js&"
export * from "./loseDetail.vue?vue&type=script&lang=js&"
import style0 from "./loseDetail.vue?vue&type=style&index=0&id=34346275&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34346275",
  null
  
)

export default component.exports